import { Card } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import IconButton from '@material-ui/core/IconButton';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import EditIcon from '@material-ui/icons/Edit';
import { useSelector } from 'react-redux';
// example https://codesandbox.io/s/f71wj?file=/demo.js:9610-9615
import { testIntervalsInSecs } from '../Flashcards/Flashcardselection';

const headCells = [
  { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
  { id: 'logo', numeric: false, disablePadding: false, label: '' },
  {
    id: 'numCards',
    numeric: false,
    disablePadding: false,
    label: 'No. of Flashcards',
  },
  {
    id: 'numActiveCards',
    numeric: false,
    disablePadding: false,
    label: 'No. of active Flashcards',
  },
  {
    id: 'numTestCards',
    numeric: false,
    disablePadding: false,
    label: 'No. of testable Flashcards',
  },
];

const idKey = (id) => (id == null ? '' : String(id));

function Trainingslist({ trainings, setCurrentId, handleClickOpen }) {
  const flashcardHeaders = useSelector((state) => state.flashcardHeaders);

  const reducer = (accumulator, currentValue) => accumulator + currentValue;

  const countActiveFlashcardsInTraining = (training) => {
    if (!training.active) {
      return 0;
    }
    if (!training.flashcardIds?.length) {
      return 0;
    }
    return training.flashcardIds.reduce((count, flashcardId) => {
      const flashCard = flashcardHeaders.find(
        (card) => idKey(card._id) === idKey(flashcardId),
      );
      if (flashCard?.header?.active) {
        return count + 1;
      }
      return count;
    }, 0);
  };

  const countTestableFlashcardsInTraining = (training) => {
    if (!training.active) {
      return 0;
    }
    if (!training.flashcardIds?.length) {
      return 0;
    }
    return training.flashcardIds
      .map((flashcardId) => {
        const flashCard = flashcardHeaders.find(
          (card) => idKey(card._id) === idKey(flashcardId),
        );
        if (
          flashCard !== undefined &&
          flashCard.header.active &&
          (Date.parse(flashCard.header.lastpass) +
            testIntervalsInSecs[flashCard.header.passlevel] * 1000 <
            Date.parse(new Date().toISOString()) ||
            flashCard.header.passlevel === 0)
        ) {
          return 1;
        }
        return 0;
      })
      .reduce(reducer);
  };

  const totals = trainings.reduce(
    (acc, training) => ({
      flashcards: acc.flashcards + (training.flashcardIds?.length ?? 0),
      active: acc.active + countActiveFlashcardsInTraining(training),
      testable: acc.testable + countTestableFlashcardsInTraining(training),
    }),
    { flashcards: 0, active: 0, testable: 0 },
  );

  const summaryRowStyle = {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    fontWeight: 600,
  };

  return (
    <Card style={{ margin: '10px', display: 'inline-block' }}>
      <Table>
        <TableHead>
          <TableRow key="headrow">
            {headCells.map((headCell) => (
              <TableCell
                key={headCell.id}
                align={headCell.numeric ? 'right' : 'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                style={{
                  padding: '5px',
                }}
              >
                {headCell.label}
              </TableCell>
            ))}
            <TableCell
              key={'edit'}
              align={'left'}
              style={{
                padding: '5px',
              }}
            >
              {'Edit Training'}
            </TableCell>
            <TableCell
              key={'train'}
              align={'left'}
              style={{
                padding: '5px',
              }}
            >
              {'Do Training'}
            </TableCell>
          </TableRow>
          {trainings.map((training) => (
            <TableRow
              key={`${training._id}_title_row`}
              // hover
            >
              <TableCell
                key={`${training._id}_name`}
                style={{
                  padding: '5px',
                  color: training.active ? '' : 'gray',
                }}
              >
                {training.name}
              </TableCell>
              <TableCell
                key={`${training._id}_logo`}
                style={{
                  padding: '5px',
                  color: training.active ? '' : 'gray',
                }}
              >
                {training.logo !== undefined && training.logo !== '' ? (
                  <img
                    id={`${training._id}_trainingslogo`}
                    src={training.logo}
                    height="30"
                    style={{ border: '0px solid rgba(0, 0, 0, 1.0)' }}
                  />
                ) : (
                  <></>
                )}
              </TableCell>
              <TableCell
                key={`${training._id}_numCards`}
                style={{ padding: '5px' }}
              >
                {training.flashcardIds.length}
              </TableCell>
              <TableCell
                key={`${training._id}_numActiveCards`}
                style={{
                  padding: '5px',
                  color: training.active ? '' : 'gray',
                }}
              >
                {countActiveFlashcardsInTraining(training)}
              </TableCell>
              <TableCell
                key={`${training._id}_numTestCards`}
                style={{
                  padding: '5px',
                  color: training.active ? '' : 'gray',
                }}
              >
                {countTestableFlashcardsInTraining(training)}
              </TableCell>
              <TableCell
                key={`${training._id}_edit`}
                style={{ padding: '5px' }}
              >
                <IconButton
                  onClick={() => setCurrentId(training._id)}
                  aria-label="edit button"
                  size="small"
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
              <TableCell
                key={`${training._id}_train`}
                style={{ padding: '5px' }}
                // onClick={() => setCurrentId(training._id)}
              >
                <IconButton
                  onClick={(e) => {
                    handleClickOpen(e, training.name);
                  }}
                  aria-label="edit button"
                  size="small"
                >
                  <DirectionsRunIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {trainings.length > 0 ? (
            <TableRow key="trainings_summary_row">
              <TableCell
                key="summary_name"
                style={{ ...summaryRowStyle, padding: '5px' }}
              >
                All trainings (total)
              </TableCell>
              <TableCell
                key="summary_logo"
                style={{ ...summaryRowStyle, padding: '5px' }}
              />
              <TableCell
                key="summary_numCards"
                style={{ ...summaryRowStyle, padding: '5px' }}
              >
                {totals.flashcards}
              </TableCell>
              <TableCell
                key="summary_numActive"
                style={{ ...summaryRowStyle, padding: '5px' }}
              >
                {totals.active}
              </TableCell>
              <TableCell
                key="summary_numTestable"
                style={{ ...summaryRowStyle, padding: '5px' }}
              >
                {totals.testable}
              </TableCell>
              <TableCell
                key="summary_edit"
                style={{ ...summaryRowStyle, padding: '5px' }}
              />
              <TableCell
                key="summary_train"
                style={{ ...summaryRowStyle, padding: '5px' }}
              />
            </TableRow>
          ) : null}
        </TableHead>
      </Table>
    </Card>
  );
}

export default Trainingslist;
